import { render, staticRenderFns } from "./sparesTab.vue?vue&type=template&id=7a9c1b19"
import script from "./sparesTab.js?vue&type=script&lang=js&external"
export * from "./sparesTab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports